import { render, staticRenderFns } from "./ProjectProgressBadge.vue?vue&type=template&id=cb43c5ac"
import script from "./ProjectProgressBadge.vue?vue&type=script&lang=js"
export * from "./ProjectProgressBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports